import React from 'react';
import { ITags } from 'types';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import classNames from 'classnames';
import style from './Items.module.scss';

interface IItems {
	tag: ITags;
	isShowItems: boolean;
	isShowAdditionalTags: boolean;
}

const Items: React.FC<IItems> = ({ tag, isShowItems, isShowAdditionalTags }) => {
	const containerClasses = classNames(style.container, { [style.showContainer]: isShowItems });

	return (
		<div className={containerClasses}>
			{tag.tags.map((el, i) => {
				const inputWrapperClasses = classNames(style.inputWrapper, {
					[style.hideAdditionalTag]: i > 2 && !isShowAdditionalTags,
				});

				return (
					<div className={inputWrapperClasses} key={tag.languageId + String(i)}>
						<FullInfoField
							label="tagLabel"
							translationOptions={{ counterValue: String(i + 1) }}
							value={el}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default React.memo(Items);
